<template>
  <div class="report-source-table-cell">
    {{getSource}}
  </div>
</template>

<script>
import { REPORT_SOURCES } from '@/constants/report';

export default {
  name: 'ReportSourceTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getSource() {
      if (this.item?.source === REPORT_SOURCES.DISCOVERY) {
        return this.$t('reportsTable.source.discovery');
      }
      if (this.item?.source === REPORT_SOURCES.VULNERABILITY_ASSESSMENT) {
        return this.$t('reportsTable.source.vulnerability_assessment');
      }
      if (this.item?.source === REPORT_SOURCES.CLOUD_COMPLIANCE) {
        return this.$t('reportsTable.source.cloud.compliance');
      }
      return this.$t('reportsTable.source.discovery.employees');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.report-source-table-cell {
  max-height: rem(48);
  font-family: $font-family-regular;
  color: var(--text-primary);
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(16);
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-top: rem(5);
}
</style>
